import { create } from 'zustand';

export type ThemeMode = 'light' | 'dark' | 'system';

interface ThemeState {
  mode:     ThemeMode;
  resolved: 'light' | 'dark';
  setMode:  (m: ThemeMode) => void;
  init:     () => () => void;
}

function getSystem(): 'light' | 'dark' {
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

function applyToDOM(isDark: boolean): void {
  document.documentElement.classList.toggle('dark', isDark);
}

export const useThemeStore = create<ThemeState>()((set, get) => ({
  mode:     'system',
  resolved: 'light',

  setMode(mode) {
    const resolved = mode === 'system' ? getSystem() : mode;
    localStorage.setItem('cp_theme', mode);
    applyToDOM(resolved === 'dark');
    set({ mode, resolved });
  },

  init() {
    const saved = (localStorage.getItem('cp_theme') as ThemeMode | null) ?? 'system';
    const resolved = saved === 'system' ? getSystem() : saved;
    applyToDOM(resolved === 'dark');
    set({ mode: saved, resolved });

    const mq = window.matchMedia('(prefers-color-scheme: dark)');
    const onChange = (e: MediaQueryListEvent) => {
      if (get().mode === 'system') {
        const r: 'light' | 'dark' = e.matches ? 'dark' : 'light';
        applyToDOM(e.matches);
        set({ resolved: r });
      }
    };
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  },
}));
